export default __webpack_public_path__ + "671b5043d9cf2b09d774892b18935d3e.svg";